<template>
  <el-container class="container">
    <transition name="slide-fade">
      <div v-show="isSwitch" class="aside-cont">
        <div class="logo">
          <div class="f-imgtopbox2">
            <transition>
              <!--<img class="img2" src="../assets/img/logo4.png" alt="">-->
              <img class="img2" :src="logoUrl" alt="">
            </transition>
          </div>
        </div>
        <!--<ul class="index_side_list">-->
          <!--<li v-for="(item,index) in asideList" :class="$route.path == item.path?'active':''"-->
              <!--@click="urlReplace(item,index)" :key="index" style="cursor: pointer">-->
            <!--&lt;!&ndash;v-if="item.icon"&ndash;&gt;-->
            <!--<div class="content_right">-->
              <!--<p><i :class="item.icon"></i><span style="margin-left: 5px;">{{item.name}}</span></p>-->
            <!--</div>-->
          <!--</li>-->
        <!--</ul>-->
        <div v-show="isSwitch" class="icon_switch" style="right:-15px;" @click="isSwitch=!isSwitch">
          <i :class=" isSwitch?'el-icon-caret-left':'el-icon-caret-right'"></i>
        </div>
        <v-left-nav-bar></v-left-nav-bar>
      </div>
    </transition>
    <el-container class="w100 h100">
      <el-header class="header flex-box">
        <h4 class="g-proName">企业工作门户平台</h4>
        <ul class="header_right flex-box">
          <li @click="chooseCompanyDialog = true" v-if="showSwitchCompany">
            <i class="iconfont icon-qiehuan"></i>
            <span>切换公司</span>
          </li>
          <li>
            <!-- <i class="el-icon-setting"></i> -->
            <el-dropdown trigger="click" @command="selectDropdown">
                <li class="last" style="padding-right:0;border: none;">
                  <span class="el-dropdown-link">
                    <i class="iconfont icon-gerenxinxi"></i>
                   {{$store.state.adminName}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                </li>
              <el-dropdown-menu slot="dropdown">
                <div @click="loginOut">
                  <el-dropdown-item :command="1">退出</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </el-header>
      <el-main class="main w100 h100">
        <router-view></router-view>
      </el-main>
    </el-container>
    <transition name="slide-fade">
      <div v-if="!isSwitch" class="icon_switch" style="left:0;" @click="isSwitch=!isSwitch">
        <i :class=" isSwitch?'el-icon-caret-left':'el-icon-caret-right'"></i>
      </div>
    </transition>
    <el-dialog title="请选择登录企业" class="append-body" :visible.sync="chooseCompanyDialog" :append-to-body="true"
               width="700px" center top="3%">
      <v-switch-company v-if="chooseCompanyDialog" :companyIcList="companyIcList"
                     @closeDialog="load()"></v-switch-company>
    </el-dialog>
    <!-- <v-switch-company v-if="$store.state.switchCompanyDialog"></v-switch-company> -->
  </el-container>
</template>
<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    data() {
      return {
        isSwitch: true,
        applicationActive: 0,
        active: '',
        name: '',
        seacrhcont: '',
        path: '',
        adminPortraitUrl: '',
        headerNavList: [],
        nowSystem: 0,
        url: this.$route.path,
        query: this.$route.query.single,
        myPermission: {},
        logoUrl: '',
        chooseCompanyDialog: false,
        showSwitchCompany: false,
      }
    },
    created() {
    },
    mounted() {
      this.logoUrl = sessionStorage.getItem('logoUrl');
      this.switchCompany();
      // getData.getChannelIdByChannelUrl().then((res) => {
      //   if (res.data.code == 1) {
      //     // return
      //     this.logoUrl = res.data.url;
      //   }
      // })
    },
    methods: {
      selectDropdown(val) {
        console.log(val)
      },
      urlReplace(item, index) {
       /* this.applicationActive = index;*/
        this.$router.push({path: item.path})
      },
      goOther(item, index) {
        this.isActive = item.id;
        this.$router.push({path: item.path})
      },
      judgeBuildingDetail(val, id) {
        if (val == '/index') {
          this.$router.replace({path: '/applicationList'});
          this.applicationActive = 0;
        } else {
          if(this.asideList){
            this.asideList.forEach((item, index) => {
              if (val.indexOf(item.path) != -1) {
                this.applicationActive = index;
              }
            })
          }
        }
      },
      loginOut() {
        this.$confirm('是否确认退出?', '提示', {
          type: 'warning'
        }).then(() => {
          let allSessionId = sessionStorage.getItem("allSessionId");
          getData.logout(allSessionId).then((res) => {
            sessionStorage.clear();
            if (res.data.code == 'success') {
              this.$router.push({path: '/login'})
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              this.$router.push({path: '/login'})
            }
          }).catch(() => {
            this.$router.push({path: '/login'})
          });
        }).catch(() => {
        })
      },
      switchCompany(){//切换公
        getData.userCompanyList().then((res) => {
          if (res.data.code != 1) {
            return
          }
          this.companyIcList = res.data.data;
          if(this.companyIcList.length > 1){
            this.showSwitchCompany = true;
          }
        }).catch(_ => {
        })
      },
      load(){
        this.chooseCompanyDialog=false;
        // setTimeout()
        setTimeout(() => {
          history.go(0);
      }, 1000);
        // history.go(0);
      }
    },
    watch: {
      '$route'(val) {
        this.judgeBuildingDetail(val.path)
      }
    }
  }
</script>
<style lang="scss">
  @import '../assets/css/mixin';
  .g-proName{
    @include sc(18px,#fff);
    font-weight: 700;
    margin-left: 26px;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .container {
    width: 100%;
    height: 100%;
    background-color: #f8f8f9;
    /*min-width: 1300px;*/
    .header {
      height: 58px;
      padding: 0;
      background-color: #50566B;
      justify-content: space-between;
      .collapse {
        padding: 0 16px;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        i {
          color: #2a92e7;
          font-size: 20px;
        }
        &:hover {
          background-color: rgba(42, 146, 231, .2);
        }
      }
      .g-searchinput {
        margin-left: 35px;
        width: 229px;
        height: 43px;
      }
      .crumb-box {
        flex: 1;
      }
      .user-box {
        margin-right: 30px;
        .btn {
          color: #657984;
          padding: 0 10px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          &:hover {
            background-color: rgba(42, 146, 231, .2);
          }
          i {
            font-size: 20px;
          }
        }
      }
      .navbar li.el-menu-item:hover {
        background-color: rgb(80, 86, 107);
      }
    }
    .aside-cont {
      position: relative;
      background-color: #333743;
      .logo {
        position: relative;
        height: 90px;
        /*background-color: #f8f8f9;*/
        overflow: hidden;
        position: relative;
        text-align: center;
        padding: 0 10px;
        .f-imgtopbox {
          position: absolute;
          top: 20px;
          left: 50%;
          margin-left: -24px;
          @include wh(45px, 49px);
        }
        .f-imgtopbox2 {
          position: absolute;
          top: 20px;
          left: 50%;
          margin-left: -80px;
          @include wh(160px, 49px);
        }
        .img1 {
          width: 45px;
        }
        .img2 {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      > .el-menu {
        height: calc(100% - 182px);
        height: -moz-calc(100% - 182px);
        height: -webkit-calc(100% - 182px);
        border-right: none;
        background-color: transparent;
        text-align: left;
        &:not(.el-menu--collapse) {
          width: 270px;
          overflow: auto
        }
      }
      .g-userinfo {
        position: relative;
        height: 90px;
        border-bottom: 2px solid #333743;
        .imgsboxs {
          position: relative;
          width: 52px;
          height: 52px;
          border: 1px solid #007de3;
          border-radius: 50%;
          margin-right: 20px;
          img {
            width: 52px;
            height: 52px;
            object-fit: cover;
            border-radius: 50%;
          }
          &:after {
            position: absolute;
            content: '';
            right: 0;
            bottom: 6px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #007de3;
            border: 1px solid #fff;
          }
        }
        .smallimgsboxs {
          position: absolute;
          margin: 0;
          top: 18px;
          left: 50%;
          margin-left: -26px;
        }
      }
    }
    .main {
      /*margin: 15px;*/
      padding: 0px;
      /*padding-top: 5px;*/
      position: relative;
      /*border-radius: 3px;*/
      background: #fff;
      /*border-top: 3px solid #d2d6de;*/
      /*margin-bottom: 20px;*/
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      flex: 1;
      .main-box {
        overflow: auto;
        /*padding: 15px;*/
        min-width: 930px;
        padding-bottom: 20px;
        flex: 1;
      }
    }
    .main1 {
      position: relative;
      flex: 1;
      .main-box {
        overflow: auto;
        min-width: 1030px;
        flex: 1;
      }
    }
  }

  .img {
    width: 55px;
    height: 35px;
    margin-right: 10px;
  }

  .content_right {
    flex: 1;
  }

  .index_side_list {
    padding: 20px 10px;
    padding-left: 0;
    max-height: 100%;
    box-sizing: border-box;
    overflow: auto;
    li {
      display: flex;
      padding: 10px;
      width: 161px;
      border-left: 3px solid #333743;
      margin-top: 4px;
      h3 {
        color: #fff;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
      p {
        color: rgba(51, 204, 255, 0.768627450980392);
        font-size: 10px;
      }
      i {
        font-size: 14px;
      }
    }
    .active {
      background: #14161b;
      border-left: 3px solid #0CB1F8;
      color: #fff;
      p {
        i, span {
          color: #fff;
        }
      }
    }
    .active2 {
      background: #0BABF7;
      border: 1px solid #0BABF7;
      p {
        color: #fff;
      }
    }
  }

  .side_btn {
    background: #333743;
    color: #0BABF7;
    border: 1px solid rgba(11, 171, 247, 1);
    width: 100%;
  }

  .side_btn:hover, .side_btn:focus {
    background: #333743;
    color: #0BABF7;
    border: 1px solid rgba(11, 171, 247, 1);
  }

  .header_nav {
    /*width: 60%;*/
    margin-left: 20px;
    li {
      /*flex: 1;*/
      text-align: center;
      border-bottom: 4px solid #50566B;
      color: #fff;
      margin-left: 20px;
      padding: 18px 20px;
      cursor: pointer;
      p {
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
      }
    }
    li:hover {
      border-bottom: 4px solid #0BABF7;
      color: #0BABF7;
    }
    .active {
      border-bottom: 4px solid #0BABF7;
      color: #0BABF7;
    }
  }

  .header_right {
    color: #fff;
    margin-right: 20px;
    li {
      padding: 2px 20px;
      border-right: 1px solid #fff;
      i {
        font-size: 20px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
      span {
        font-weight: 700;
        font-style: normal;
        font-size: 12px;
        color: #fff;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .active {
      color: #12BBF0;
      span {
        color: #12BBF0;
      }
    }
    li:last-child {
      border: 0;
    }
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateX(-200px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue